<div class="contact-section">
  <div class="contact-container">
    <div class="left-side"> 
      <div class="contact-title">
        Besoin d’aide?   
     </div>
     <div class="contact-description">Vous avez des questions, des commentaires ou des suggestions ? N'hésitez pas à nous contacter. Notre équipe est à votre disposition pour vous aider.</div>

    </div>
    

    <!-- <div class="line">

      <svg width="0.1vw" height="20vw" viewBox="0 0 1 269" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="0.5" x2="0.5" y2="269" stroke="white"/>
      </svg>
    
    </div> -->

    <div class="email-container">
      <div class="button">
        <a href="https://trendit.fr/contact" target="_blank"> <strong> Contactez-nous </strong> </a> 
       
      </div>
    </div>
  </div>
</div>
    